import React from 'react'
import Navbar from './Navbar';
import "../Modules/valueprop.css";
import Contact from './Contact';

const ContactPage = () => {
  return (
    <>
    <div className="bg-dark fixed-top">
    <Navbar/>
    </div> <br />
    <center>
    <section className="aboutSection" style={{backgroundColor:'white'}} > <br />
    <h2 className='ourMissionHeading' style={{color: 'black',marginTop:'5px',marginBottom:'5px',backgroundColor:'white'}}>Contact Us</h2>

    <div class="col-md-5 my-4">
                     <div style={{backgroundColor: '#008102',padding:'20px',color:'white', borderRadius:'20px',textAlign:'center'}}>
                        <h1>Get in Touch! </h1> <br />
                        <h5>We would love to hear from you!</h5> <br />
                        <p>Whether you have a question, comment, or a suggestion, feel free to drop a message in any of our social media button below. We’ll get back to you as soon as possible.</p> <br />
                     <div style={{display:'flex',justifyContent:'space-evenly'}}>
                           <div> <a href="https://wa.me/+2348165570286"><i class="fa-brands fa-whatsapp"style={{fontSize: '200%',color: 'white'}}></i></a> </div>
                           <div> <a href="https://www.linkedin.com/company/food-supply-vision/about/?viewAsMember=true"><i class="fa-brands fa-linkedin"style={{fontSize: '200%',color: 'white'}}></i></a> </div>
                           <div> <a href="https://www.instagram.com/ojaami.com_official?igsh=MW1pdzM0aDJpcG5icQ%3D%3D&utm_source=qr"><i class="fa-brands fa-instagram"style={{fontSize: '200%',color: 'white'}}></i></a> </div>
                           <div> <a href="mailto:Admin@foodsupplyvision.com"><i class="fa-solid fa-envelope"style={{fontSize: '200%',color: 'white'}}></i></a> </div>
                     </div>
                     </div>
                  </div>
    </section>
    </center>
    <div >
       <Contact/>
    </div>
    </>
  )
}

export default ContactPage;